import { inject, Injectable, signal } from '@angular/core';
import { LoggingService } from '@common/logging/logging.service';

export interface NetworkLogEntry {
  timestamp: string;
  method: string;
  url: string;
  status: number;
  durationMs: number;
}

const MAX_ENTRIES = 200;

@Injectable({ providedIn: 'root' })
export class NetworkLogService {
  readonly #logger = inject(LoggingService);
  readonly enabled = signal(false);
  readonly entries = signal<NetworkLogEntry[]>([]);

  enable(): void {
    this.enabled.set(true);
    this.#logger.info(
      `[NetworkLogService] Enabled — logging HTTP requests, buffer max ${MAX_ENTRIES}`
    );
  }

  disable(): void {
    this.enabled.set(false);
    this.#logger.info(
      '[NetworkLogService] Disabled — HTTP request logging stopped'
    );
  }

  clear(): void {
    this.entries.set([]);
  }

  log(entry: NetworkLogEntry): void {
    this.entries.update(prev => {
      const next = [...prev, entry];
      return next.length > MAX_ENTRIES ? next.slice(-MAX_ENTRIES) : next;
    });
  }
}
